import { createApp } from 'vue';
import pinia from '/@/stores/index';
import App from '/@/App.vue';
import router from '/@/router';
import { directive } from '/@/directive/index';
import { i18n } from '/@/i18n/index';
import other from '/@/utils/other';

import ElementPlus from 'element-plus';
import '/@/theme/index.scss';
import VueGridLayout from 'vue-grid-layout';

import * as echarts from 'echarts'
import particles from "vue3-particles"


const app = createApp(App)

// 全局挂载 echarts
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$i18n = i18n.global

directive(app);
other.elSvg(app);

app.use(pinia).use(router).use(ElementPlus).use(i18n).use(VueGridLayout).use(particles).mount('#app');
